import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class DepositRecordService {

    constructor(
        private httpService: HttpService) { }

    //获取用户的充值记录
    getDepositRecord(
        userName:string,
        startDate:string,
        endDate:string,
        pageSize:number,
        pageIndex:number
        ) {
        var url = AppConfig.GetProdUrl()+ "/User/Charge?userName="+userName+"&startDate="+startDate+"&endDate="+endDate+"&pageSize="+pageSize+"&pageIndex="+pageIndex;
        return this.httpService.get(url);
    }

}


// WEBPACK FOOTER //
// ./src/services/depositRecord.service.ts